const config = require('../../../config.json');
export default {
    apiUrl: () => {
        const host = window.location.host; // includes port
        const hostname = window.location.hostname;
        const protocol = window.location.protocol;
        const endpoint = config.proxy ? `${host}` :
            `${hostname}:${config.apiPort}`;
        return `${protocol}//${endpoint}${config.namespace}`;
    },
};



/** WEBPACK FOOTER **
 ** ./src/utils/ApiURL.js
 **/